import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import { formatImage, formatUrl } from '@ifeng/three_terminal/es/base/publicMethod/index';
import { Event as UiBaseEvent, cookie } from '@ifeng/three_terminal/es/base/base/index';
import { Slides } from '@ifeng/three_terminal/es/mobile/index';
import styles from './index.css';
import { rel as relText } from '../../../utils/rel';
import { handleAd } from '../../../utils/handleAd';
import Locationhref from '../Locationhref';

class SliderComponent extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        componentOptions: PropTypes.object,
    };

    constructor(...argv) {
        super(...argv);

        this.width = typeof window === 'object' ? window.innerWidth : null;

        const {
            content,
            componentOptions: { extendData, length },
        } = this.props;

        const formatData = this.formatData(content, extendData, length);

        this.state = {
            data: formatData,
            pinyin: cookie.get('auto_py'),
        };
    }
    componentDidMount() {
        const { componentOptions } = this.props;

        // 插入广告
        if (componentOptions.ad) {
            const dataKey = componentOptions.dataKey || 'allData';
            const ad = window[dataKey][componentOptions.ad];

            if (ad) this.getAd(ad);
        }
    }
    // 获取广告
    async getAd(ad) {
        const len = this.state.data.length;
        const callback = await handleAd(ad);
        const event = new UiBaseEvent();

        callback(ad.data, event, this.insert);
        event.trigger('init', {
            len,
            index: 0,
        });
    }
    insert = (insertArr, replaceArr, adFn) => {
        console.log('SliderComponent Callback.', insertArr, replaceArr, adFn);

        if (adFn && typeof adFn === 'function') {
            const { data } = this.state;

            const infoData = [...data];
            const refs = [];

            insertArr.forEach(item => {
                const ref = createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 0, { type: 'ad', ref });
            });

            replaceArr.forEach(item => {
                const ref = createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 1, { type: 'ad', ref });
            });

            this.setState(
                {
                    data: infoData,
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        dom[ref.index] = ref.ref.current;
                    }

                    adFn(dom);
                },
            );
        }
    };
    // 轮播图数据处理
    formatData(data = [], extendData = [], length = 5) {
        let dLen = length;

        // 先计算extendData内的数据
        const extendDataResult = [];

        for (const item of extendData) {
            dLen = length - item.componentOptions.length;

            for (const item2 of item.data) {
                extendDataResult.push({
                    id: item2.id,
                    thumbnail: item2.thumbnail,
                    url: formatUrl(item2.url),
                    title: item2.title,
                });
            }
        }

        // 主数据至少为1条
        if (dLen <= 0) dLen = 1;

        const mainData = [];

        for (let i = 0, j = dLen > data.length ? data.length : dLen; i < j; i++) {
            const item = data[i];

            mainData.push({
                id: item.id,
                thumbnail: item.thumbnail,
                url: formatUrl(item.url),
                title: item.title,
            });
        }

        return mainData.concat(extendDataResult).slice(0, length);
    }
    imageAttr(num) {
        if (this.width === null) {
            return num;
        } else {
            return parseInt((this.width / 375) * num);
        }
    }
    getDpr() {
        let dpr = 1;

        // 默认以2倍图显示，1倍图可能会模糊
        if (typeof window === 'object') {
            // 获取请求的用户代理头
            const navigatorUserAgent = typeof window === 'object' ? window.navigator.userAgent : null;
            // 判断是否是iphone
            const iPhone = navigatorUserAgent ? navigatorUserAgent.indexOf('iPhone') : -1;

            dpr = iPhone > -1 ? Number(window.devicePixelRatio) : 1;
        }

        return dpr === 1 ? 2 : dpr;
    }
    sliderTmplView(width, height, item) {
        if (item.type === 'ad') return <div ref={item.ref} className={styles.tmpBox} />;
        if (item.type === 'loc') return item.data;

        const { thumbnail, title, url } = item;
        const dpr = this.getDpr();

        return (
            <a className={styles.tmpBox} href={formatUrl(url)} target="_blank" rel={relText}>
                <img
                    className={styles.image}
                    src={formatImage(thumbnail, 375 * dpr, 188 * dpr)}
                    alt={title}
                    width={width}
                    height={height}
                />
                <div className={styles.txtBox}>
                    <p className={styles.txt}>{title}</p>
                </div>
            </a>
        );
    }
    dotTmpl(current, total) {
        const dots = [];

        for (let i = 0; i < total; i++) {
            dots.push(<span key={i} className={current === i ? styles.current : styles.dots} />);
        }

        return <div className={styles.dotsBox}>{dots}</div>;
    }
    render() {
        const width = this.imageAttr(375);
        const height = this.imageAttr(188);
        const { data } = this.state;

        const config = {
            sliderTmpl: this.sliderTmplView.bind(this, width, height),
            dotTmpl: this.dotTmpl,
            autoplay: true,
            autoplayInterval: 10000,
        };

        return (
            <div className={styles.box}>
                <Slides content={data} config={config} />
                <Locationhref />
            </div>
        );
    }
}

export default SliderComponent;
